import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';


class Fleets {

    getFleetsBarCharts({ organizationIds, siteIds, countryCodes, assetGroupIds, refreshData = false }) {
        const endpoint = formatEndpoint(endpoints.fleets.barCharts);
        return RestManagerWithoutBaseUrl.post(endpoint, { organizationIds, siteIds, countryCodes, assetGroupIds, refreshData });
    }

    getFleetStatistics(tab, { organizationIds, siteIds, countryCodes, assetGroupIds, pageNumber, pageSize, refreshData = false }) {
        const endpoint = formatEndpoint(endpoints.fleets.statistics, { tab });
        return RestManagerWithoutBaseUrl.post(endpoint, { organizationIds, siteIds, countryCodes, assetGroupIds, refreshData, pageNumber, pageSize });
    }

    getFleetAnalyticsAggregated(tab, { organizationIds, siteIds, countryCodes, assetGroupIds, refreshData = false }) {
        const endpoint = formatEndpoint(endpoints.fleets.analyticsAggregated, { tab });
        return RestManagerWithoutBaseUrl.post(endpoint, { organizationIds, siteIds, countryCodes, assetGroupIds, refreshData });
    }

    /* FLEET DASHBOARD */
    getFleetAssetGroup(payload) {
        const endpoint = formatEndpoint(endpoints.assetDetails.getAssetGroups);
        return RestManagerWithoutBaseUrl.post(endpoint, { ...payload });
    }

}

export default new Fleets();
